import { render, staticRenderFns } from "./AdminExcludedKeywordsComponent.vue?vue&type=template&id=43c75999"
import script from "./AdminExcludedKeywordsComponent.vue?vue&type=script&lang=js"
export * from "./AdminExcludedKeywordsComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminExcludedKeywordsComponent.vue?vue&type=style&index=0&id=43c75999&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports